import React from 'react';
import { Logo } from './Logo';
import { Cta } from './Cta';
import { useScore } from './ScoreContext';
export function Nav() {
  const {
    answeredCount,
    openDiagnostic
  } = useScore();
  const ctaLabel = answeredCount === 0 ? 'Get Your Reader-to-Revenue Score' : answeredCount < 4 ? 'Continue Your Score' : 'Finish Your Score';
  const handleCtaClick = () => {
    openDiagnostic();
  };
  return <header className="sticky top-0 z-40 w-full border-b border-gray-100 bg-paper/80 shadow-sm backdrop-blur-md" data-id="element-306" data-mp="1g0h0ycrrshwt">
      <div className="mx-auto flex w-full max-w-[90rem] items-center justify-between px-5 py-5 md:px-8 lg:px-10" data-id="element-307" data-mp="1kxqotnziglij">
      <Logo data-id="element-308" data-mp="1pq0klknb4fsq" />
      <div className="hidden md:block" data-id="element-309" data-mp="1pqa8n2oskcvs">
        <Cta variant="primary" onClick={handleCtaClick} className="px-5 py-2.5 text-sm shadow-sm hover:shadow" data-id="element-310" data-mp="1uobqxlee8867">
          
          {ctaLabel}
        </Cta>
      </div>
      </div>
    </header>;
}